import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const ContentNuacom = lib.styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  flex-direction: column;
  overflow: hidden;

  &::-webkit-scrollbar { width: 0!important; height: 0!important; }
  overflow: -moz-scrollbars-none!important; }
  -ms-overflow-style: none!important; }
`;

export const MainContent = lib.styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: ${colors.white};
  /* overflow: hidden!important; */
  overflow: scroll;
`;
